import { render, staticRenderFns } from "./person-split-bill-record.vue?vue&type=template&id=1d518d45&scoped=true"
import script from "./person-split-bill-record.vue?vue&type=script&lang=js"
export * from "./person-split-bill-record.vue?vue&type=script&lang=js"
import style0 from "./person-split-bill-record.vue?vue&type=style&index=0&id=1d518d45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d518d45",
  null
  
)

export default component.exports